var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgError = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 40,
    fill: "#EC4B4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9142 26.5857C29.1332 25.8047 27.8668 25.8047 27.0858 26.5857C26.3047 27.3668 26.3047 28.6331 27.0858 29.4142L37.6716 40L27.0858 50.5857C26.3048 51.3668 26.3048 52.6331 27.0858 53.4142C27.8669 54.1952 29.1332 54.1952 29.9142 53.4142L40.5 42.8284L51.0858 53.4142C51.8668 54.1952 53.1332 54.1952 53.9142 53.4142C54.6953 52.6331 54.6953 51.3668 53.9142 50.5858L43.3284 40L53.9142 29.4142C54.6953 28.6331 54.6953 27.3668 53.9142 26.5857C53.1332 25.8047 51.8668 25.8047 51.0858 26.5857L40.5 37.1715L29.9142 26.5857Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/error.173032c5da0c178984649d86df6e74b9.svg";